<script setup>
import {Link}  from '@inertiajs/vue3';

import {ref} from 'vue';

const showDropdown = ref(false);

</script>

<template>

	<div>

		<div class="dropdown-menu-wrapper" id="account-menu-wrapper">

			<div class="p-1 lnr" @click="showDropdown = !showDropdown">
				<i class="lnr icon-user"></i> <span class="d-none d-xl-inline">{{
					__('my_account')
				}}</span>
			</div>

			<transition name="fade-y">

				<ul class="dropdown-menu-content" v-if="showDropdown">

					<li class="dropdown-title">
						<span class="font-semibold text-black text-nowrap ">{{ __('account') }}</span>
					</li>

					<!-- If user logged in-->
					<template v-if="$page.props.auth.user">

						<li>
							<Link :href="route('account')" :title="__('account')">
								<i class="lnr icon-user-lock"></i> <span>{{ __('my_account') }}</span>
							</Link>
						</li>

						<li>
							<Link :href="route('account.orders')" :title="__('my_orders')">
								<i class="lnr icon-eye"></i> <span>{{ __('my_orders') }}</span>
							</Link>
						</li>

						<li class="border-top-1 mt-1">
							<Link :href="route('logout')" class="logout d-flex" method="post" :title=" __('logout') " as="button" preload="auto">
								<i class="lnr icon-exit"></i> <span>{{ __('logout') }}</span>
							</Link>
						</li>

					</template>

					<!-- If User = Guest -->
					<template v-else>

						<li>
							<Link :href="route('login')" :title="__('login')">
								<i class="lnr icon-user-lock"></i> <span>{{ __('log_in') }}</span>
							</Link>
						</li>

						<li v-if="!$page.props.store.is_b2b || $page.props.auth.user">
							<Link :href="route('register')" :title="__('register')">
								<i class="lnr icon-user-plus"></i> <span>{{ __('register') }}</span>
							</Link>
						</li>

						<li v-if="$page.props.store.is_b2b && !$page.props.auth.user">
							<Link :href="route('reseller.register')" :title="__('register')">
								<i class="lnr icon-user-plus"></i> <span>{{ __('register') }}</span>
							</Link>
						</li>

					</template>

				</ul>

			</transition>

		</div>

		<div class="dropdown-menu-background" v-if="showDropdown" @click="showDropdown = false"></div>

	</div>

</template>

<script>
export default {
	name: "MyAccountMenuItem"
}
</script>

<style scoped>

</style>